import {
  Autocomplete,
  Box,
  Card,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
  createFilterOptions,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import Button from "@mui/material/Button";
import React, { useState } from "react";
import { useEffect } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../../../../components/services/api";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import { DesktopDatePicker } from "@mui/lab";
import { useParams } from "react-router";
import { saveAs } from "file-saver";
import mime from "mime";

export default function Advanpayment() {
  const { id } = useParams();
  const filter = createFilterOptions();
  const [bodyPrint, setBodyPrint] = useState({
    CostType: "Advance%20Payment",
    CostId: "",
  });
  const [currency, setCurrency] = useState([]);
  const [vat, setVat] = useState("");
  const [loading, setLoading] = useState(false);

  const [invoiceNo, setInvoiceNo] = useState("");
  const [status, setStatus] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [issueDate, setIssueDate] = useState(null);
  const [advancePayment, setAdvancePayment] = useState([]);
  const [currencyId, setCurrencyId] = useState("");
  const [exchangRate, setExchangRate] = useState("");
  const [invoice, setInvoice] = useState([]);
  const [addInvoice, setAddInvoice] = useState(false);
  const [rows, setRows] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [ResponsibleBy, setResponsibleBy] = useState(null);
  const [ApprovedBy, setApprovedBy] = useState(null);
  const [payTo, setPayTo] = useState(null);
  const [billTo, setBillTo] = useState(null);
  const [company, setCompany] = useState([]);
  const [masterCompany, setMasterCompany] = useState([]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  function addRow() {
    const newRow = {
      id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
      AdvancePaymentDetailId: null,
      Charge: "",
      TaxPercent: 0,
      Quantity: 0,
      PricePerUnit: 0,
      ExchangeRate: 1,
      Amount: 0,
      TaxAmount: 0,
      WithholdingTaxAmount: 0,
      TotalAmount: 0,
      AmountTHB: 0,
      TaxAmountTHB: 0,
      WithholdingTaxAmountTHB: 0,
      TotalAmountTHB: 0,
    };

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {
    const data = rows?.filter((e) => i !== e?.id);
    setRows(data);
  };
  const getCompany = async () => {
    try {
      const res = await api.get(`api/master/biller-payer`);
      setCompany(res?.data?.data);

      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };
  const getEmployee = async () => {
    try {
      const res = await api.get(`api/master/employee`);
      setEmployee(res?.data.data);

      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };

  const getAdvancePayment = async () => {
    try {
      const data = await api.get(`api/saleorder/detail/advancepayment/${id}`);
      if (data.data.AdvancePaymentPreset) {
        setRows(
          data.data.AdvancePaymentPreset.Detail.map((item, i) => {
            return {
              id: i + 1,
              AdvancePaymentDetailId: null,
              Charge: item?.Charge,
              TaxPercent: item?.TaxPercent || "0",
              Quantity: item?.Quantity,
              PricePerUnit: item?.PricePerUnit,
              Amount: item?.TotalTHB || 0,
              TaxAmount: item?.TotalTax || 0,
              WithholdingTaxAmount: 0,
              TotalAmount: 0,
              AmountTHB: 0,
              TaxAmountTHB: 0,
              WithholdingTaxAmountTHB: 0,
              TotalAmountTHB: 0,
              ExchangeRate: 1,
            };
          })
        );
        // setAgentName(data.data.CostPreset.AgentName)
        setPayTo(data.data.AdvancePaymentPreset.PayTo);
      }
      setAdvancePayment(data?.data?.AdvancePayment);
      setStatus(data?.data?.AdvancePaymentStatus);
      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };
  const getCurrency = async () => {
    try {
      const res = await api.get(`api/master/currency`);
      setCurrency(res?.data);

      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };
  const getVat = async () => {
    const res = await api.get(`api/master/Vatvalue`);
    const data = await res.data.data;
    if (res.meta.status === true) {
      setVat(data);
    }
  };
  const getMasterCompany = async () => {
    const res = await api.get(`api/master/company`);
    const data = await res.data.data;
    if (res.meta.status === true) {
      setMasterCompany(data);
    }
  };
  useEffect(() => {
    getAdvancePayment();
    getCurrency();
    getVat();
    getCompany();
    getEmployee();
    getMasterCompany();
  }, []);
  const updateFieldAndTotals = (rows, data, fieldName, value) => {
    const body = rows.map((v) => {
      if (v.id === data.id) {
        const updatedRow = {
          ...v,
          [fieldName]: value,
        };

        const updatedTotal = +updatedRow.Quantity * +updatedRow.PricePerUnit;
        const updatedTotalTax =
          updatedTotal * (+(+updatedRow.TaxPercent || 0) / 100);
        const updatedWithholdingTax =
          updatedTotal * (+(updatedRow.WithholdingTaxPercent || 0) / 100);
        const updatedTotalAmount =
          updatedTotal + (updatedTotalTax - updatedWithholdingTax);
        const updatedTotalTHB = updatedTotal * +updatedRow.ExchangeRate;
        const updatedTotalTaxTHB = updatedTotalTax * +updatedRow.ExchangeRate;
        const updatedWithholdingTaxTHB =
          updatedWithholdingTax * +updatedRow.ExchangeRate;
        const updatedTotalAmountTHB =
          updatedTotalAmount * +updatedRow.ExchangeRate;

        return {
          ...updatedRow,
          Amount: updatedTotal,
          TaxAmount: updatedTotalTax,
          WithholdingTaxAmount: updatedWithholdingTax,
          TotalAmount: updatedTotalAmount,
          AmountTHB: updatedTotalTHB,
          TaxAmountTHB: updatedTotalTaxTHB,
          WithholdingTaxAmountTHB: updatedWithholdingTaxTHB,
          TotalAmountTHB: updatedTotalAmountTHB,
        };
      }

      return v;
    });
    setRows(body);
  };
  const download = async (CostType, CostId, CompanyCode) => {
    setLoading(true)
    await api
      .get(
        `api/report/cost-request-form/download/pdf?CostType=${CostType}&CostId=${CostId}&CompanyCode=${CompanyCode}`,
        {
          responseType: "blob",
          timeout: 30000,
        }
      )
      .then((blobFile) => {
        const blobFileRes = new File([blobFile?.data], "test.[pdf]", {
          type: mime.getType(".pdf"),
        });

        // window.open(
        //   URL.createObjectURL(blobFileRes, "test.csv"),
        //   "_blank"
        // );
        saveAs(blobFileRes, `advanpatment-request-form-${CompanyCode}.pdf`);
        setLoading(false)
      })
      .catch((errpr) => {
        setLoading(false)
      });
  };
  return (
    <>
      <Box
        sx={{
          width: "100%",
          marginTop: "10px",
          paddingBottom: "24px",
        }}
      >
        <Box sx={{ display: "flex" }}>
          {" "}
          <FormControl sx={{ width: "25%" }}>
            <InputLabel>Status</InputLabel>
            <Select
              label="Status"
              value={status}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setStatus(e.target.value)}
            >
              <MenuItem value="Waiting Invoice">Waiting Invoice</MenuItem>
              <MenuItem value="Pending Payment">Pending Payment</MenuItem>
              <MenuItem value="Paid">Paid</MenuItem>
              <MenuItem value="Credit">Credit</MenuItem>
            </Select>
          </FormControl>
          <Button
            variant="contained"
            onClick={() => {
              const body = {
                SaleOrderId: id,
                AdvancePaymentStatus: status,
              };
              const postStatus = async () => {
                const res = await api.post(
                  `api/saleorder/update/advancepayment/status`,
                  body
                );
                if (res.meta.status) {
                  Swal.fire({
                    title: `${res.meta.message}`,
                    icon: "success",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "OK",
                    allowOutsideClick: false,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      getAdvancePayment();
                    }
                  });
                }
              };
              postStatus();
            }}
          >
            <SaveIcon sx={{ marginRight: "5px" }} /> save status
          </Button>
        </Box>
        <Button
          type="button"
          variant="contained"
          disabled={isEdit !== false ? true : false}
          style={{
            background: "#80c340",
            borderColor: "#80c340",
            marginTop: "10px",
          }}
          onClick={() => setAddInvoice(true)}
        >
          <AddIcon /> Add Invoice
        </Button>
        {addInvoice && (
          <Card
            variant="outlined"
            sx={{
              marginTop: "25px",
              padding: "40px",
              boxShadow:
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
            }}
          >
            <Grid container>
              <Grid xs={4} sx={{ marginRight: "15px" }}>
                <TextField
                  value={invoiceNo}
                  onChange={(e) => setInvoiceNo(e.target.value)}
                  fullWidth
                  label="Invoice No."
                  variant="outlined"
                />
              </Grid>
              <Grid xs={4}>
                <DesktopDatePicker
                  label="Issue Date"
                  inputFormat="yyyy/MM/dd"
                  // disablePast
                  onChange={(newValue) => {
                    setIssueDate(newValue);
                  }}
                  value={issueDate}
                  renderInput={(params) => (
                    <TextField sx={{ width: "100%" }} {...params} />
                  )}
                />
              </Grid>

              <Grid xs={4} sx={{ marginRight: "15px", marginTop: "15px" }}>
                <Autocomplete
                  freeSolo
                  options={company}
                  getOptionLabel={(option) => {
                    if (typeof option === "string") {
                      return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    // Regular option
                    return option?.Name;
                  }}
                  id="controlled-demo"
                  value={billTo}
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string") {
                      setBillTo({
                        Name: newValue,
                      });
                    } else if (newValue && newValue.inputValue) {
                      // Create a new value from the user input
                      setBillTo({
                        Name: newValue.inputValue,
                      });
                    } else {
                      setBillTo(newValue);
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some(
                      (option) => inputValue === option.Name
                    );
                    if (inputValue !== "" && !isExisting) {
                      filtered.push({
                        inputValue,
                        Name: `Add "${inputValue}"`,
                      });
                    }

                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  renderInput={(params) => (
                    <TextField {...params} label="Bill To" />
                  )}
                />
              </Grid>
              <Grid xs={4} sx={{ marginRight: "15px", marginTop: "15px" }}>
                {/* <TextField
                  label="Agent Name"
                  value={
                    agentName
                  }
                  onChange={(e) => {
                    setAgentName(e.target.value)
                  }}
                  sx={{ width: '100%' }}
                /> */}
                <Autocomplete
                  freeSolo
                  options={company}
                  getOptionLabel={(option) => {
                    if (typeof option === "string") {
                      return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    // Regular option
                    return option?.Name;
                  }}
                  id="controlled-demo"
                  value={payTo}
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string") {
                      setPayTo({
                        Name: newValue,
                      });
                    } else if (newValue && newValue.inputValue) {
                      // Create a new value from the user input
                      setPayTo({
                        Name: newValue.inputValue,
                      });
                    } else {
                      setPayTo(newValue);
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some(
                      (option) => inputValue === option.Name
                    );
                    if (inputValue !== "" && !isExisting) {
                      filtered.push({
                        inputValue,
                        Name: `Add "${inputValue}"`,
                      });
                    }

                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  renderInput={(params) => (
                    <TextField {...params} label="Pay To" />
                  )}
                />
              </Grid>
            </Grid>
            <Button
              type="button"
              variant="contained"
              style={{
                background: "#80c340",
                borderColor: "#80c340",
                marginTop: "10px",
              }}
              onClick={addRow}
            >
              <AddIcon /> Add
            </Button>
            <div style={{ overflowX: "auto" }}>
              <TableContainer
                sx={{ marginTop: 2, marginBottom: 2, width: "200%" }}
              >
                <Table stickyHeader>
                  <TableRow>
                    <TableCell align="center" width="100px">
                      #
                    </TableCell>
                    <TableCell align="center" width="200px">
                      Charge
                    </TableCell>

                    <TableCell align="center" width="100px">
                      Tax%
                    </TableCell>
                    <TableCell align="center" width="150px">
                      Withholding Tax%
                    </TableCell>
                    <TableCell align="center" width="100px">
                      Quantity
                    </TableCell>
                    <TableCell align="center" width="100px">
                      Price / Unit
                    </TableCell>
                    <TableCell align="center" width="100px">
                      Currency
                    </TableCell>
                    <TableCell align="center" width="100px">
                      Exchang Rate
                    </TableCell>
                    <TableCell align="center" width="100px">
                      Amount
                    </TableCell>
                    <TableCell align="center" width="100px">
                      Tax Amount
                    </TableCell>
                    <TableCell align="center" width="100px">
                      Withholding Tax
                    </TableCell>
                    <TableCell align="center" width="100px">
                      Total Amount
                    </TableCell>
                    <TableCell align="center" width="100px">
                      Amount (THB)
                    </TableCell>
                    <TableCell align="center" width="120px">
                      Tax Amount (THB)
                    </TableCell>
                    <TableCell align="center" width="130px">
                      Withholding Tax (THB)
                    </TableCell>
                    <TableCell align="center" width="120px">
                      Total Amount (THB)
                    </TableCell>
                    <TableCell align="center" width="100px"></TableCell>

                    {/* <TableCell align="center" width="15%">TaxTotal</TableCell> */}
                  </TableRow>
                  {rows?.map((data, index) => {
                    return (
                      <TableBody key={index}>
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="center">
                          <TextField
                            label="Charge"
                            value={data?.Charge || ""}
                            onChange={(e) => {
                              updateFieldAndTotals(
                                rows,
                                data,
                                "Charge",
                                e.target.value
                              );
                            }}
                          />
                        </TableCell>

                        <TableCell align="center">
                          <FormControl fullWidth>
                            <InputLabel>Tax</InputLabel>
                            <Select
                              label="Tax"
                              value={data?.TaxPercent || ""}
                              onChange={(e) => {
                                updateFieldAndTotals(
                                  rows,
                                  data,
                                  "TaxPercent",
                                  e.target.value
                                );
                              }}
                              InputLabelProps={{ shrink: true }}
                            >
                              {vat?.map((x) => (
                                <MenuItem value={x?.VatvalueNumber}>
                                  {x?.VatvalueNumber}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell align="center">
                          <FormControl fullWidth>
                            <InputLabel>Withholding Tax</InputLabel>
                            <Select
                              label="Withholding Tax"
                              value={data?.WithholdingTaxPercent || ""}
                              onChange={(e) => {
                                updateFieldAndTotals(
                                  rows,
                                  data,
                                  "WithholdingTaxPercent",
                                  e.target.value
                                );
                              }}
                              InputLabelProps={{ shrink: true }}
                            >
                              {vat?.map((x) => (
                                <MenuItem value={x?.VatvalueNumber}>
                                  {x?.VatvalueNumber}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            label="Quantity"
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            value={data?.Quantity}
                            onChange={(e) => {
                              updateFieldAndTotals(
                                rows,
                                data,
                                "Quantity",
                                e.target.value
                              );
                            }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            label="Price/Unit"
                            value={data?.PricePerUnit}
                            type="number"
                            sx={{
                              "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                                {
                                  display: "none",
                                },
                              "& input[type=number]": {
                                MozAppearance: "textfield",
                              },
                            }}
                            onChange={(e) => {
                              updateFieldAndTotals(
                                rows,
                                data,
                                "PricePerUnit",
                                e.target.value
                              );
                            }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <FormControl fullWidth>
                            <InputLabel>Currency</InputLabel>
                            <Select
                              label="Currency"
                              value={data?.CurrencyId}
                              InputLabelProps={{ shrink: true }}
                              onChange={(e) => {
                                updateFieldAndTotals(
                                  rows,
                                  data,
                                  "CurrencyId",
                                  e.target.value
                                );
                              }}
                            >
                              {currency?.map((x) => (
                                <MenuItem value={x?.CurrencyId}>
                                  {x?.CurrencyCode}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            label="Exchang Rate"
                            value={data?.ExchangeRate || ""}
                            // value={data?.ExchangeRate}
                            onChange={(e) => {
                              updateFieldAndTotals(
                                rows,
                                data,
                                "ExchangeRate",
                                e.target.value
                              );
                            }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            label="Amount"
                            value={+data.Amount?.toFixed(2)}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            label="Tax Amount"
                            value={+data.TaxAmount?.toFixed(2)}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            label="Withholding Tax"
                            value={+data.WithholdingTaxAmount?.toFixed(2)}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            label="Total Amount"
                            value={+data.TotalAmount?.toFixed(2)}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            label="Amount"
                            value={+data.AmountTHB?.toFixed(2)}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            label="Tax Amount"
                            value={+data.TaxAmountTHB?.toFixed(2)}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            label="Withholding Tax"
                            value={+data.WithholdingTaxAmountTHB?.toFixed(2)}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            label="Total Amount"
                            value={+data.TotalAmountTHB?.toFixed(2)}
                          />
                        </TableCell>
                        {/* <TableCell align="center">

                        <TextField
                          label="TaxTotal"
                          value={
                            +rows?.filter((c) => c?.id === data?.id)[0]?.Quantity *
                            ((+rows?.filter((c) => c?.id === data?.id)[0]?.PricePerUnit * (+rows?.filter((c) => c?.id === data?.id)[0]?.TaxPercent / 100)) + +rows?.filter((c) => c?.id === data?.id)[0]?.PricePerUnit)
                          }
                        // onChange={(e) => {
                        //   const io = rows?.map((v) => {
                        //     v.Total =
                        //       v?.id === data?.id ? e.target.value : v?.Total;

                        //     return v;
                        //   });

                        //   setRows([...io]);
                        // }}
                        />
                      </TableCell> */}

                        <TableCell align="center">
                          <Button
                            type="button"
                            variant="outlined"
                            style={{
                              color: "#80c340",
                              borderColor: "#80c340",
                            }}
                            onClick={() => deletehand(data?.id)}
                          >
                            Delete
                          </Button>
                        </TableCell>
                      </TableBody>
                    );
                  })}
                </Table>
              </TableContainer>
            </div>
            <Table sx={{ marginBottom: "15px" }}>
              <TableRow>
                <TableCell align="center" width="40%"></TableCell>
                <TableCell align="center" width="20%"></TableCell>
                <TableCell align="center" width="30%"></TableCell>
                <TableCell align="center" width="10%"></TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={1} rowSpan={4} />
                <TableCell colSpan={1}>Total Amount (Excluding Tax)</TableCell>
                <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                  {parseFloat(
                    rows?.length > 1
                      ? rows
                          ?.map((s) => s?.AmountTHB || 0)
                          ?.reduce((a, b) => a + b)
                          .toFixed(2)
                      : rows?.length === 1
                      ? rows[0]?.AmountTHB.toFixed(2)
                      : 0,
                    10
                  )
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                </TableCell>
                <TableCell colSpan={1}>THB</TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan={1}>Withholding Tax</TableCell>
                <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                  {parseFloat(
                    rows?.length > 1
                      ? rows
                          ?.map((s) => s?.WithholdingTaxAmountTHB || 0)
                          ?.reduce((a, b) => a + b)
                          .toFixed(2)
                      : rows?.length === 1
                      ? rows[0]?.WithholdingTaxAmountTHB.toFixed(2)
                      : 0,
                    10
                  )
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                </TableCell>
                <TableCell colSpan={1}>THB</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={1}>TotalTax</TableCell>
                <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                  {parseFloat(
                    rows?.length > 1
                      ? rows
                          ?.map((s) => s?.TaxAmountTHB || 0)
                          ?.reduce((a, b) => a + b)
                          .toFixed(2)
                      : rows?.length === 1
                      ? rows[0]?.TaxAmountTHB.toFixed(2)
                      : 0,
                    10
                  )
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                </TableCell>
                <TableCell colSpan={1}>THB</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={1}>TotalAmount</TableCell>
                <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                  {parseFloat(
                    rows?.length > 1
                      ? rows
                          ?.map((s) => s?.TotalAmountTHB || 0)
                          ?.reduce((a, b) => a + b)
                          .toFixed(2)
                      : rows?.length === 1
                      ? (rows[0]?.TotalAmountTHB).toFixed(2)
                      : 0,
                    10
                  )
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                </TableCell>
                <TableCell colSpan={1}>THB</TableCell>
              </TableRow>
            </Table>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Autocomplete
                  // freeSolo
                  fullWidth
                  options={employee}
                  getOptionLabel={(option) =>
                    `${option?.firstname} ${option?.lastname}`
                  }
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.EmpNo}>
                      {option?.firstname} {option?.lastname}
                    </Box>
                  )}
                  id="controlled-demo"
                  value={ResponsibleBy}
                  onChange={(event, newValue) => {
                    setResponsibleBy(newValue);
                  }}
                  // filterOptions={(options, params) => {
                  //   const filtered = filter(options, params);

                  //   const { inputValue } = params;
                  //   // Suggest the creation of a new value
                  //   const isExisting = options.some((option) => inputValue === option.Name);
                  //   if (inputValue !== '' && !isExisting) {
                  //     filtered.push({
                  //       inputValue,
                  //       Name: `Add "${inputValue}"`,
                  //     });
                  //   }

                  //   return filtered;
                  // }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  renderInput={(params) => (
                    <TextField {...params} label="RESPONSIBILITY" />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  freeSolo
                  fullWidth
                  options={employee}
                  getOptionLabel={(option) =>
                    `${option?.firstname} ${option?.lastname}`
                  }
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.EmpNo}>
                      {option?.firstname} {option?.lastname}
                    </Box>
                  )}
                  id="controlled-demo"
                  value={ApprovedBy}
                  onChange={(event, newValue) => {
                    setApprovedBy(newValue);
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  renderInput={(params) => (
                    <TextField {...params} label="Approved" />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    height: "100%",
                  }}
                >
                  <Button
                    type="button"
                    variant="contained"
                    style={{
                      background: "#d33",
                      borderColor: "#d33",
                      marginRight: "10px",
                      width: "200px",
                    }}
                    onClick={() => {
                      setRows([]);
                      setAddInvoice(false);
                      setCurrencyId("");
                      setInvoiceNo("");
                      setIssueDate(null);
                      setBillTo(null);
                      setPayTo(null);
                      setApprovedBy(null);
                      setResponsibleBy(null);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    // type="button"
                    disabled={invoiceNo && issueDate ? false : true}
                    variant="contained"
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      width: "200px",
                    }}
                    onClick={() => {
                      const body = {
                        SaleOrderId: id,
                        AdvancePaymentId: null,
                        InvoiceNo: invoiceNo,
                        IssueDate: moment(issueDate).format("yyyy-MM-DD"),
                        CurrencyId: currencyId.toString(),
                        ExchangeRate: exchangRate,

                        BillTo: billTo?.Name || "",
                        PayTo: payTo?.Name || payTo,
                        ResponsibleBy: ResponsibleBy?.firstname
                          ? `${ResponsibleBy?.firstname} ${ResponsibleBy?.lastname}`
                          : "",
                        ApprovedBy: ApprovedBy?.firstname
                          ? `${ApprovedBy?.firstname} ${ApprovedBy?.lastname}`
                          : "",
                          Total:
                          rows?.length > 1
                            ? rows
                                ?.map((s) => s?.AmountTHB)
                                ?.reduce((a, b) => a + b)
                            : rows?.length === 1
                            ? rows[0]?.AmountTHB
                            : 0,
                        TaxAmount:
                          rows?.length > 1
                            ? +rows
                                ?.map((s) => s?.TaxAmountTHB)
                                ?.reduce((a, b) => a + b)
                                .toFixed(2)
                            : rows?.length === 1
                            ? +rows[0]?.TaxAmountTHB.toFixed(2)
                            : 0,
                        WithholdingTaxAmount:
                          rows?.length > 1
                            ? +rows
                                ?.map((s) => s?.WithholdingTaxAmountTHB)
                                ?.reduce((a, b) => a + b)
                                .toFixed(2)
                            : rows?.length === 1
                            ? +rows[0]?.WithholdingTaxAmountTHB.toFixed(2)
                            : 0,
                        TotalAmount:
                          rows?.length > 1
                            ? +rows
                                ?.map((s) => s?.TotalAmountTHB)
                                ?.reduce((a, b) => a + b)
                                .toFixed(2)
                            : rows?.length === 1
                            ? +(rows[0]?.TaxAmountTHB).toFixed(2)
                            : 0,
                        Status: true,
                        Detail: rows,
                      };
                      const postInvoice = async () => {
                        const res = await api.post(
                          `api/saleorder/update/advancepayment/invoice`,
                          body
                        );
                        if (res.meta.status) {
                          Swal.fire({
                            title: `${res.meta.message}`,
                            icon: "success",
                            confirmButtonColor: "#3085d6",
                            confirmButtonText: "OK",
                            allowOutsideClick: false,
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setRows([]);
                              setAddInvoice(false);
                              setCurrencyId("");
                              setInvoiceNo("");
                              setIssueDate(null);
                              setExchangRate("");
                              getAdvancePayment();
                              setBillTo(null);
                              setPayTo(null);
                              setApprovedBy(null);
                              setResponsibleBy(null);
                            }
                          });
                        }
                      };
                      postInvoice();
                    }}
                  >
                    Save
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Card>
        )}
        {advancePayment?.map((x, i) => (
          <Card
            variant="outlined"
            sx={{
              marginTop: "25px",
              padding: "40px",
              boxShadow:
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
            }}
          >
            <Grid container>
              <Grid xs={4} sx={{ marginRight: "15px" }}>
                <TextField
                  value={x.InvoiceNo}
                  disabled={isEdit !== x?.AdvancePaymentId}
                  onChange={(e) => {
                    const io = advancePayment?.map((v) => {
                      v.InvoiceNo =
                        v?.AdvancePaymentId === x?.AdvancePaymentId
                          ? e.target.value
                          : v?.InvoiceNo;

                      return v;
                    });

                    setAdvancePayment([...io]);
                  }}
                  fullWidth
                  label="Invoice No."
                  variant="outlined"
                />
              </Grid>
              <Grid xs={4}>
                <DesktopDatePicker
                  disabled={isEdit !== x?.AdvancePaymentId}
                  label="Issue Date"
                  inputFormat="yyyy/MM/dd"
                  onChange={(newValue) => {
                    setIssueDate(newValue);
                    const io = advancePayment?.map((v) => {
                      v.IssueDate =
                        v?.AdvancePaymentId === x?.AdvancePaymentId
                          ? moment(newValue).format("yyyy-MM-DD")
                          : v?.IssueDate;

                      return v;
                    });

                    setAdvancePayment([...io]);
                  }}
                  value={x.IssueDate}
                  renderInput={(params) => (
                    <TextField sx={{ width: "100%" }} {...params} />
                  )}
                />
              </Grid>
              {/* <Grid xs={4} sx={{ marginRight: "15px", marginTop: "15px" }}>
                <FormControl fullWidth>
                  <InputLabel>Currency</InputLabel>
                  <Select
                    disabled={isEdit !== x?.AdvancePaymentId}
                    label="Currency"
                    value={x.CurrencyId}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => {
                      const io = advancePayment?.map((v) => {
                        v.CurrencyId =
                          v?.AdvancePaymentId === x?.AdvancePaymentId
                            ? e.target.value
                            : v?.CurrencyId;
                        if (
                          "THB" ===
                          currency?.find(
                            (x) => x?.CurrencyId === e.target.value
                          )?.CurrencyCode
                        ) {
                          v.ExchangeRate =
                            v?.AdvancePaymentId === x?.AdvancePaymentId
                              ? 1
                              : v?.ExchangeRate;
                        } else {
                          v.ExchangeRate =
                            v?.AdvancePaymentId === x?.AdvancePaymentId
                              ? ""
                              : v?.ExchangeRate;
                        }
                        return v;
                      });

                      setAdvancePayment([...io]);
                    }}
                  >
                    {currency?.map((x) => (
                      <MenuItem value={x?.CurrencyId}>
                        {x?.CurrencyCode}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid xs={4} sx={{ marginTop: "15px" }}>
                <TextField
                  value={x.ExchangeRate}
                  disabled={isEdit !== x?.AdvancePaymentId}
                  onChange={(e) => {
                    const io = advancePayment?.map((v) => {
                      v.ExchangeRate =
                        v?.AdvancePaymentId === x?.AdvancePaymentId
                          ? e.target.value
                          : v?.ExchangeRate;

                      return v;
                    });

                    setAdvancePayment([...io]);
                  }}
                  fullWidth
                  label="Exchang Rate"
                  variant="outlined"
                />
              </Grid> */}
              <Grid xs={4} sx={{ marginRight: "15px", marginTop: "15px" }}>
                <Autocomplete
                  disabled={isEdit !== x?.AdvancePaymentId}
                  freeSolo
                  options={company}
                  getOptionLabel={(option) => {
                    if (typeof option === "string") {
                      return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    // Regular option
                    return option?.Name;
                  }}
                  id="controlled-demo"
                  value={x?.BillTo}
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string") {
                      const io = advancePayment?.map((v) => {
                        v.BillTo =
                          v?.AdvancePaymentId === x?.AdvancePaymentId
                            ? newValue
                            : v?.BillTo;

                        return v;
                      });

                      setAdvancePayment([...io]);
                    } else if (newValue && newValue.inputValue) {
                      // Create a new value from the user input
                      const io = advancePayment?.map((v) => {
                        v.BillTo =
                          v?.AdvancePaymentId === x?.AdvancePaymentId
                            ? newValue.inputValue
                            : v?.BillTo;

                        return v;
                      });

                      setAdvancePayment([...io]);
                    } else {
                      const io = advancePayment?.map((v) => {
                        v.BillTo =
                          v?.AdvancePaymentId === x?.AdvancePaymentId
                            ? newValue
                            : v?.BillTo;

                        return v;
                      });

                      setAdvancePayment([...io]);
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some(
                      (option) => inputValue === option.Name
                    );
                    if (inputValue !== "" && !isExisting) {
                      filtered.push({
                        inputValue,
                        Name: `Add "${inputValue}"`,
                      });
                    }

                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  renderInput={(params) => (
                    <TextField {...params} label="Bill To" />
                  )}
                />
              </Grid>
              <Grid xs={4} sx={{ marginRight: "15px", marginTop: "15px" }}>
                {/* <TextField
                  label="Agent Name"
                  value={x.AgentName} disabled={isEdit !== x?.SaleOrderCostId} onChange={e => {
                    const io = cost?.map((v) => {
                      v.AgentName =
                        v?.SaleOrderCostId === x?.SaleOrderCostId ? e.target.value : v?.AgentName;

                      return v;
                    });
                    setCost([...io]);
                  }}
                  sx={{ width: '100%' }}
                /> */}
                <Autocomplete
                  disabled={isEdit !== x?.AdvancePaymentId}
                  freeSolo
                  options={company}
                  getOptionLabel={(option) => {
                    if (typeof option === "string") {
                      return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    // Regular option
                    return option?.Name;
                  }}
                  id="controlled-demo"
                  value={x?.PayTo}
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string") {
                      const io = advancePayment?.map((v) => {
                        v.PayTo =
                          v?.AdvancePaymentId === x?.AdvancePaymentId
                            ? newValue
                            : v?.PayTo;

                        return v;
                      });

                      setAdvancePayment([...io]);
                    } else if (newValue && newValue.inputValue) {
                      // Create a new value from the user input
                      const io = advancePayment?.map((v) => {
                        v.PayTo =
                          v?.AdvancePaymentId === x?.AdvancePaymentId
                            ? newValue.inputValue
                            : v?.PayTo;

                        return v;
                      });

                      setAdvancePayment([...io]);
                    } else {
                      const io = advancePayment?.map((v) => {
                        v.PayTo =
                          v?.AdvancePaymentId === x?.AdvancePaymentId
                            ? newValue
                            : v?.PayTo;

                        return v;
                      });

                      setAdvancePayment([...io]);
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some(
                      (option) => inputValue === option.Name
                    );
                    if (inputValue !== "" && !isExisting) {
                      filtered.push({
                        inputValue,
                        Name: `Add "${inputValue}"`,
                      });
                    }

                    return filtered;
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  renderInput={(params) => (
                    <TextField {...params} label="Pay To" />
                  )}
                />
              </Grid>
            </Grid>
            {/* <Button
              type="button"
              variant="contained"
              style={{
                background: "#80c340",
                borderColor: "#80c340",
                marginTop: "10px",
              }}
              onClick={addRow}
            >
              <AddIcon /> Add
            </Button> */}{" "}
            {isEdit == x?.AdvancePaymentId ? (
              <>
                <Button
                  type="button"
                  variant="contained"
                  style={{
                    background: "#80c340",
                    borderColor: "#80c340",
                    marginTop: "10px",
                  }}
                  onClick={addRow}
                >
                  <AddIcon /> Add
                </Button>
                <div style={{ overflowX: "auto", marginBottom: "10px" }}>
                  <TableContainer
                    sx={{ marginTop: 2, marginBottom: 2, width: "200%" }}
                  >
                    <Table stickyHeader>
                      <TableRow>
                        <TableCell align="center" width="100px">
                          #
                        </TableCell>
                        <TableCell align="center" width="200px">
                          Charge
                        </TableCell>

                        <TableCell align="center" width="100px">
                          Tax%
                        </TableCell>
                        <TableCell align="center" width="150px">
                          Withholding Tax%
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Quantity
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Price / Unit
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Currency
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Exchang Rate
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Amount
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Tax Amount
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Withholding Tax
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Total Amount
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Amount (THB)
                        </TableCell>
                        <TableCell align="center" width="120px">
                          Tax Amount (THB)
                        </TableCell>
                        <TableCell align="center" width="130px">
                          Withholding Tax (THB)
                        </TableCell>
                        <TableCell align="center" width="120px">
                          Total Amount (THB)
                        </TableCell>
                        <TableCell align="center" width="100px"></TableCell>

                        {/* <TableCell align="center" width="15%">TaxTotal</TableCell> */}
                      </TableRow>

                      {rows?.map((data, index) => {
                        return (
                          <TableBody key={index}>
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Charge"
                                value={data?.Charge || ""}
                                onChange={(e) => {
                                  updateFieldAndTotals(
                                    rows,
                                    data,
                                    "Charge",
                                    e.target.value
                                  );
                                }}
                              />
                            </TableCell>

                            <TableCell align="center">
                              <FormControl fullWidth>
                                <InputLabel>Tax</InputLabel>
                                <Select
                                  label="Tax"
                                  value={data?.TaxPercent || ""}
                                  onChange={(e) => {
                                    updateFieldAndTotals(
                                      rows,
                                      data,
                                      "TaxPercent",
                                      e.target.value
                                    );
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                >
                                  {vat?.map((x) => (
                                    <MenuItem value={x?.VatvalueNumber}>
                                      {x?.VatvalueNumber}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </TableCell>
                            <TableCell align="center">
                              <FormControl fullWidth>
                                <InputLabel>Withholding Tax</InputLabel>
                                <Select
                                  label="Withholding Tax"
                                  value={data?.WithholdingTaxPercent || ""}
                                  onChange={(e) => {
                                    updateFieldAndTotals(
                                      rows,
                                      data,
                                      "WithholdingTaxPercent",
                                      e.target.value
                                    );
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                >
                                  {vat?.map((x) => (
                                    <MenuItem value={x?.VatvalueNumber}>
                                      {x?.VatvalueNumber}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Quantity"
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                value={data?.Quantity}
                                onChange={(e) => {
                                  updateFieldAndTotals(
                                    rows,
                                    data,
                                    "Quantity",
                                    e.target.value
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Price/Unit"
                                value={data?.PricePerUnit}
                                type="number"
                                sx={{
                                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                                    {
                                      display: "none",
                                    },
                                  "& input[type=number]": {
                                    MozAppearance: "textfield",
                                  },
                                }}
                                onChange={(e) => {
                                  updateFieldAndTotals(
                                    rows,
                                    data,
                                    "PricePerUnit",
                                    e.target.value
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <FormControl fullWidth>
                                <InputLabel>Currency</InputLabel>
                                <Select
                                  label="Currency"
                                  value={data?.CurrencyId}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={(e) => {
                                    updateFieldAndTotals(
                                      rows,
                                      data,
                                      "CurrencyId",
                                      e.target.value
                                    );
                                  }}
                                >
                                  {currency?.map((x) => (
                                    <MenuItem value={x?.CurrencyId}>
                                      {x?.CurrencyCode}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Exchang Rate"
                                value={data?.ExchangeRate || ""}
                                // value={data?.ExchangeRate}
                                onChange={(e) => {
                                  updateFieldAndTotals(
                                    rows,
                                    data,
                                    "ExchangeRate",
                                    e.target.value
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Amount"
                                value={+data.Amount?.toFixed(2)}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Tax Amount"
                                value={+data.TaxAmount?.toFixed(2)}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Withholding Tax"
                                value={+data.WithholdingTaxAmount?.toFixed(2)}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Total Amount"
                                value={+data.TotalAmount?.toFixed(2)}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Amount"
                                value={+data.AmountTHB?.toFixed(2)}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Tax Amount"
                                value={+data.TaxAmountTHB?.toFixed(2)}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Withholding Tax"
                                value={
                                  +data.WithholdingTaxAmountTHB?.toFixed(2)
                                }
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Total Amount"
                                value={+data.TotalAmountTHB?.toFixed(2)}
                              />
                            </TableCell>
                            {/* <TableCell align="center">
  
                          <TextField
                            label="TaxTotal"
                            value={
                              +rows?.filter((c) => c?.id === data?.id)[0]?.Quantity *
                              ((+rows?.filter((c) => c?.id === data?.id)[0]?.PricePerUnit * (+rows?.filter((c) => c?.id === data?.id)[0]?.TaxPercent / 100)) + +rows?.filter((c) => c?.id === data?.id)[0]?.PricePerUnit)
                            }
                          // onChange={(e) => {
                          //   const io = rows?.map((v) => {
                          //     v.Total =
                          //       v?.id === data?.id ? e.target.value : v?.Total;
  
                          //     return v;
                          //   });
  
                          //   setRows([...io]);
                          // }}
                          />
                        </TableCell> */}

                            <TableCell align="center">
                              <Button
                                type="button"
                                variant="outlined"
                                style={{
                                  color: "#80c340",
                                  borderColor: "#80c340",
                                }}
                                onClick={() => deletehand(data?.id)}
                              >
                                Delete
                              </Button>
                            </TableCell>
                          </TableBody>
                        );
                      })}
                    </Table>
                  </TableContainer>
                </div>
                <Table sx={{ marginBottom: "15px" }}>
                  <TableRow>
                    <TableCell align="center" width="40%"></TableCell>
                    <TableCell align="center" width="20%"></TableCell>
                    <TableCell align="center" width="30%"></TableCell>
                    <TableCell align="center" width="10%"></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1} rowSpan={4} />
                    <TableCell colSpan={1}>
                      Total Amount (Excluding Tax)
                    </TableCell>
                    <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                      {parseFloat(
                        rows?.length > 1
                          ? rows
                              ?.map((s) => s?.AmountTHB)
                              ?.reduce((a, b) => a + b)
                              .toFixed(2)
                          : rows?.length === 1
                          ? rows[0]?.AmountTHB.toFixed(2)
                          : 0,
                        10
                      )
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                    </TableCell>
                    <TableCell colSpan={1}>THB</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={1}>Withholding Tax</TableCell>
                    <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                      {parseFloat(
                        rows?.length > 1
                          ? rows
                              ?.map((s) => s?.WithholdingTaxAmountTHB)
                              ?.reduce((a, b) => a + b)
                              .toFixed(2)
                          : rows?.length === 1
                          ? rows[0]?.WithholdingTaxAmountTHB.toFixed(2)
                          : 0,
                        10
                      )
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                    </TableCell>
                    <TableCell colSpan={1}>THB</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1}>TotalTax</TableCell>
                    <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                      {parseFloat(
                        rows?.length > 1
                          ? rows
                              ?.map((s) => s?.TaxAmountTHB)
                              ?.reduce((a, b) => a + b)
                              .toFixed(2)
                          : rows?.length === 1
                          ? rows[0]?.TaxAmountTHB.toFixed(2)
                          : 0,
                        10
                      )
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                    </TableCell>
                    <TableCell colSpan={1}>THB</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1}>TotalAmount</TableCell>
                    <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                      {parseFloat(
                        rows?.length > 1
                          ? rows
                              ?.map((s) => s?.TotalAmountTHB)
                              ?.reduce((a, b) => a + b)
                              .toFixed(2)
                          : rows?.length === 1
                          ? (rows[0]?.TotalAmountTHB).toFixed(2)
                          : 0,
                        10
                      )
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                    </TableCell>
                    <TableCell colSpan={1}>THB</TableCell>
                  </TableRow>
                </Table>
              </>
            ) : (
              <>
                <div style={{ overflowX: "auto" }}>
                  <TableContainer
                    sx={{ marginTop: 2, marginBottom: 2, width: "200%" }}
                  >
                    <Table stickyHeader>
                      <TableRow>
                        <TableCell align="center" width="100px">
                          #
                        </TableCell>
                        <TableCell align="center" width="200px">
                          Charge
                        </TableCell>

                        <TableCell align="center" width="100px">
                          Tax%
                        </TableCell>
                        <TableCell align="center" width="150px">
                          Withholding Tax%
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Quantity
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Price / Unit
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Currency
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Exchang Rate
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Amount
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Tax Amount
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Withholding Tax
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Total Amount
                        </TableCell>
                        <TableCell align="center" width="100px">
                          Amount (THB)
                        </TableCell>
                        <TableCell align="center" width="120px">
                          Tax Amount (THB)
                        </TableCell>
                        <TableCell align="center" width="130px">
                          Withholding Tax (THB)
                        </TableCell>
                        <TableCell align="center" width="120px">
                          Total Amount (THB)
                        </TableCell>

                        {/* <TableCell align="center" width="15%">TaxTotal</TableCell> */}
                      </TableRow>

                      {x?.Detail?.map((data, index) => {
                        return (
                          <TableBody key={index}>
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">
                              <TextField
                                disabled
                                label="Charge"
                                value={data?.Charge}
                              />
                            </TableCell>

                            <TableCell align="center">
                              <TextField
                                disabled
                                label="Tax"
                                value={data?.TaxPercent}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                disabled
                                label="Withholding Tax"
                                value={data?.WithholdingTaxPercent}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                disabled
                                label="Quantity"
                                value={data?.Quantity}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                disabled
                                label="Price/Unit"
                                value={data?.PricePerUnit}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                disabled
                                label="Currency"
                                value={data?.CurrencyCode}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                disabled
                                label="Exchang Rate"
                                value={data?.ExchangeRate}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Amount"
                                disabled
                                value={data?.Amount}
                              />
                            </TableCell>

                            <TableCell align="center">
                              <TextField
                                label="Tax Amount"
                                disabled
                                value={data?.TaxPercent}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Withholding Tax"
                                disabled
                                value={data?.WithholdingTaxAmount}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Total Amount"
                                disabled
                                value={data?.TotalAmount}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Amount"
                                disabled
                                value={data?.AmountTHB}
                              />
                            </TableCell>

                            <TableCell align="center">
                              <TextField
                                label="Tax Amount"
                                disabled
                                value={data?.TaxAmountTHB}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Withholding Tax"
                                disabled
                                value={data?.WithholdingTaxAmountTHB}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <TextField
                                label="Total Amount"
                                disabled
                                value={data?.TotalAmountTHB}
                              />
                            </TableCell>
                          </TableBody>
                        );
                      })}
                    </Table>
                  </TableContainer>
                </div>
                <Table sx={{ marginBottom: "15px" }}>
                  <TableRow>
                    <TableCell align="center" width="40%"></TableCell>
                    <TableCell align="center" width="20%"></TableCell>
                    <TableCell align="center" width="30%"></TableCell>
                    <TableCell align="center" width="10%"></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1} rowSpan={4} />
                    <TableCell colSpan={1}>
                      Total Amount (Excluding Tax)
                    </TableCell>
                    <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                      {parseFloat(
                        x?.Detail?.length > 1
                          ? x?.Detail?.map((s) => s?.AmountTHB)
                              ?.reduce((a, b) => a + b)
                              .toFixed(2)
                          : x?.Detail?.length === 1
                          ? x?.Detail[0]?.AmountTHB.toFixed(2)
                          : 0,
                        10
                      )
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                    </TableCell>
                    <TableCell colSpan={1}>THB</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={1}>Withholding Tax</TableCell>
                    <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                      {parseFloat(
                        x?.Detail?.length > 1
                          ? x?.Detail?.map((s) => s?.WithholdingTaxAmountTHB)
                              ?.reduce((a, b) => a + b)
                              .toFixed(2)
                          : x?.Detail?.length === 1
                          ? x?.Detail[0]?.WithholdingTaxAmountTHB.toFixed(2)
                          : 0,
                        10
                      )
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                    </TableCell>
                    <TableCell colSpan={1}>THB</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1}>TotalTax</TableCell>
                    <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                      {parseFloat(
                        x?.Detail?.length > 1
                          ? x?.Detail?.map((s) => s?.TaxAmountTHB)
                              ?.reduce((a, b) => a + b)
                              .toFixed(2)
                          : x?.Detail?.length === 1
                          ? x?.Detail[0]?.TaxAmountTHB.toFixed(2)
                          : 0,
                        10
                      )
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                    </TableCell>
                    <TableCell colSpan={1}>THB</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1}>TotalAmount</TableCell>
                    <TableCell colSpan={1} sx={{ textAlign: "end" }}>
                      {parseFloat(
                        x?.Detail?.length > 1
                          ? x?.Detail?.map((s) => s?.TotalAmountTHB)
                              ?.reduce((a, b) => a + b)
                              .toFixed(2)
                          : x?.Detail?.length === 1
                          ? (x?.Detail[0]?.TotalAmountTHB).toFixed(2)
                          : 0,
                        10
                      )
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                    </TableCell>
                    <TableCell colSpan={1}>THB</TableCell>
                  </TableRow>
                </Table>
              </>
            )}
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Autocomplete
                  disabled={isEdit !== x?.AdvancePaymentId}
                  // freeSolo
                  fullWidth
                  options={employee}
                  getOptionLabel={(option) =>
                    `${option?.firstname || ""}${
                      option?.lastname ? " " + option?.lastname : ""
                    }`
                  }
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.EmpNo}>
                      {option?.firstname} {option?.lastname}
                    </Box>
                  )}
                  id="controlled-demo"
                  value={{ firstname: x?.ResponsibleBy }}
                  onChange={(event, newValue) => {
                    const io = advancePayment?.map((v) => {
                      v.ResponsibleBy =
                        v?.AdvancePaymentId === x?.AdvancePaymentId
                          ? `${newValue?.firstname} ${newValue?.lastname}`
                          : v?.ResponsibleBy;

                      return v;
                    });

                    setAdvancePayment([...io]);
                  }}
                  // filterOptions={(options, params) => {
                  //   const filtered = filter(options, params);

                  //   const { inputValue } = params;
                  //   // Suggest the creation of a new value
                  //   const isExisting = options.some((option) => inputValue === option.Name);
                  //   if (inputValue !== '' && !isExisting) {
                  //     filtered.push({
                  //       inputValue,
                  //       Name: `Add "${inputValue}"`,
                  //     });
                  //   }

                  //   return filtered;
                  // }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  renderInput={(params) => (
                    <TextField {...params} label="RESPONSIBILITY" />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  disabled={isEdit !== x?.AdvancePaymentId}
                  freeSolo
                  fullWidth
                  options={employee}
                  getOptionLabel={(option) =>
                    `${option?.firstname || ""}${
                      option?.lastname ? " " + option?.lastname : ""
                    }`
                  }
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.EmpNo}>
                      {option?.firstname} {option?.lastname}
                    </Box>
                  )}
                  id="controlled-demo"
                  value={{ firstname: x?.ApprovedBy }}
                  onChange={(event, newValue) => {
                    const io = advancePayment?.map((v) => {
                      v.ApprovedBy =
                        v?.AdvancePaymentId === x?.AdvancePaymentId
                          ? `${newValue?.firstname} ${newValue?.lastname}`
                          : v?.ApprovedBy;

                      return v;
                    });

                    setAdvancePayment([...io]);
                  }}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  renderInput={(params) => (
                    <TextField {...params} label="Approved" />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    height: "100%",
                  }}
                >
                  {isEdit !== x?.AdvancePaymentId ? (
                    <>
                      <Button
                        type="button"
                        variant="outlined"
                        disabled={loading}
                        style={{
                          color: "#3085d6",
                          borderColor: "#3085d6",
                          marginRight: "10px",
                          width: "200px",
                        }}
                        onClick={(e) => {
                          handleClick(e);
                          setBodyPrint({
                            ...bodyPrint,
                            CostId: x?.AdvancePaymentId,
                          });
                        }}
                      >
                         {loading ? 'Loading...' : 'print'} 
                      </Button>
                      <Button
                        type="button"
                        variant="outlined"
                        style={{
                          color: "#d33",
                          borderColor: "#d33",
                          marginRight: "10px",
                          width: "200px",
                        }}
                        onClick={() => {
                          const deleteAP = async () => {
                            const res = await api.post(
                              `api/saleorder/update/advancepayment/delete`,
                              {
                                AdvancePaymentId: x?.AdvancePaymentId,
                              }
                            );
                            if (res.meta.status) {
                              Swal.fire({
                                title: `${res.meta.message}`,
                                icon: "success",
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "OK",
                                allowOutsideClick: false,
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  setRows([]);
                                  setIsEdit(false);
                                  getAdvancePayment();
                                }
                              });
                            }
                          };
                          Swal.fire({
                            title: "Are you sure?",
                            // text: "You won't be able to revert this!",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Yes, delete it!",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              deleteAP();
                            }
                          });
                        }}
                      >
                        Delete
                      </Button>

                      <Button
                        type="button"
                        variant="contained"
                        style={{
                          background: "#80c340",
                          borderColor: "#80c340",
                          width: "200px",
                        }}
                        onClick={() => {
                          const row = x?.Detail.map((y, i) => ({
                            id: i,
                            ...y,
                            TaxPercent: y.TaxPercent || "0",
                            WithholdingTaxPercent:
                              y.WithholdingTaxPercent || "0",
                          }));
                          setRows(row);
                          setIsEdit(x?.AdvancePaymentId);
                        }}
                      >
                        Edit
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        type="button"
                        variant="contained"
                        style={{
                          background: "#d33",
                          borderColor: "#d33",
                          marginRight: "10px",
                          width: "200px",
                        }}
                        onClick={() => {
                          setRows([]);
                          setIsEdit(false);
                          getAdvancePayment();
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        // type="button"
                        variant="contained"
                        style={{
                          background: "#80c340",
                          borderColor: "#80c340",
                          width: "200px",
                        }}
                        onClick={() => {
                          const body = {
                            SaleOrderId: id,
                            AdvancePaymentId: x.AdvancePaymentId,
                            InvoiceNo: x.InvoiceNo,
                            IssueDate: x?.IssueDate,
                            CurrencyId: x?.CurrencyId,
                            ExchangeRate: x?.ExchangeRate,
                            BillTo: x?.BillTo.Name || x?.BillTo,
                            PayTo: x?.PayTo.Name || x?.PayTo,
                            ResponsibleBy: x?.ResponsibleBy?.firstname
                              ? `${x?.ResponsibleBy?.firstname} ${x?.ResponsibleBy?.lastname}`
                              : x.ResponsibleBy,
                            ApprovedBy: x.ApprovedBy.firstname
                              ? `${x?.ApprovedBy?.firstname} ${x?.ApprovedBy?.lastname}`
                              : x.ApprovedBy,
                              Total:
                              rows?.length > 1
                                ? rows
                                    ?.map((s) => s?.AmountTHB)
                                    ?.reduce((a, b) => a + b)
                                : rows?.length === 1
                                ? rows[0]?.AmountTHB
                                : 0,
                            TaxAmount:
                              rows?.length > 1
                                ? +rows
                                    ?.map((s) => s?.TaxAmountTHB)
                                    ?.reduce((a, b) => a + b)
                                    .toFixed(2)
                                : rows?.length === 1
                                ? +rows[0]?.TaxAmountTHB.toFixed(2)
                                : 0,
                            WithholdingTaxAmount:
                              rows?.length > 1
                                ? +rows
                                    ?.map((s) => s?.WithholdingTaxAmountTHB)
                                    ?.reduce((a, b) => a + b)
                                    .toFixed(2)
                                : rows?.length === 1
                                ? +rows[0]?.WithholdingTaxAmountTHB.toFixed(2)
                                : 0,
                            TotalAmount:
                              rows?.length > 1
                                ? +rows
                                    ?.map((s) => s?.TotalAmountTHB)
                                    ?.reduce((a, b) => a + b)
                                    .toFixed(2)
                                : rows?.length === 1
                                ? +(rows[0]?.TaxAmountTHB).toFixed(2)
                                : 0,
                            Status: x?.Status,
                            Detail: rows,
                          };
                          const postInvoice = async () => {
                            const res = await api.post(
                              `api/saleorder/update/advancepayment/invoice`,
                              body
                            );
                            if (res.meta.status) {
                              Swal.fire({
                                title: `${res.meta.message}`,
                                icon: "success",
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "OK",
                                allowOutsideClick: false,
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  setRows([]);
                                  setIsEdit(false);
                                  getAdvancePayment();
                                }
                              });
                            }
                          };

                          postInvoice();
                        }}
                      >
                        Update
                      </Button>
                    </>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Card>
        ))}
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {masterCompany?.map((item) => {
            return (
              <MenuItem
                onClick={
                  () => 
                    {
                    download(
                      bodyPrint.CostType,
                      bodyPrint.CostId,
                      item.CompanyCode
                    );
                    handleClose();
                  }
                  // (window.location.href = `/report/ApprovalExpenseForm/${bodyPrint.CostId}?CostType=${bodyPrint.CostType}&CompanyCode=${item.CompanyCode}`)
                }
              >
                {item.CompanyName}
              </MenuItem>
            );
          })}
        </Menu>
      </Box>
    </>
  );
}
